module.exports = __webpack_public_path__ + "img/eficiencia.a932f5e4.svg";